import { https } from "./https";
import { searchPlaces } from "./google";
import type { AuthUser } from "../stores/authStore";

export type AvailableService = {
  id: string;
  code: string;
  name: string;
  shortName: string;
  iconUrl: string | null;
  status: "ENABLED" | "DISABLED" | null;
  sortOrder: number | null;
};

export type LoginPayload = {
  email: string;
  isTCAccepted?: boolean;
};

export type VerifyCodePayload = {
  session: string;
  code: string;
  userId: string;
};

export type RefreshTokenPayload = {
  refreshToken: string;
};

export type MeResponse = AuthUser & Record<string, unknown>;

export async function login(payload: LoginPayload) {
  const { data } = await https({
    method: "post",
    url: "/auth/registerB2bExisting/",
    data: payload,
  });

  return data;
}

export async function verifyCode(payload: VerifyCodePayload) {
  const { data } = await https({
    method: "post",
    url: "/auth/verifyCode",
    data: payload,
  });

  return data;
}

export async function refreshToken(payload: RefreshTokenPayload) {
  const { data } = await https({
    data: payload,
    method: "post",
    skipAuthRefresh: true,
    url: "/auth/refreshToken/",
  });

  return data;
}

export async function me(): Promise<MeResponse> {
  const { data } = await https<{ user: AuthUser } & Record<string, unknown>>({
    method: "get",
    url: "/global/partner/me",
    params: { status: "ENABLED" },
  });

  const { user, ...others } = data;

  const registeredCity = user.user_organization?.organization?.registeredCity;

  if (!!registeredCity) {
    user.location = await (async () => {
      try {
        const { places } = await searchPlaces(registeredCity, {
          maxResultCount: 1,
        });
        return places?.[0] ?? null;
      } catch {
        return null;
      }
    })();
  }

  return { ...user, ...others };
}
